import { ApiError } from '@gorila-shared-ui/components';
import { LiveStatusConfig } from '../types/liveStatusConfig';
import { NotificationConfig } from '../types/notificationConfig';
import { getRequest, postRequest } from './api';
import { liveStatusSettingsUrl, notificationSettingsUrl } from './urls/settingsUrls';

export const getNotificationSettings = async (
  clientId: string,
  subClientId: string
): Promise<{ notificationSettings?: NotificationConfig[]; error?: ApiError }> => {
  const response = await getRequest(notificationSettingsUrl, { queryParams: { clientId, subClientId } });
  return {
    notificationSettings: response?.data,
    error: response?.error,
  };
};

export const updateNotificationSettings = async (
  clientId: string,
  subClientId: string,
  notificationSettings: NotificationConfig[]
): Promise<{ error?: ApiError }> => {
  const response = await postRequest(notificationSettingsUrl, {
    body: {
      clientId,
      subClientId,
      notificationSettings,
    },
  });

  return {
    error: response?.error,
  };
};

export const getLiveStatusSettings = async (
  clientId: string,
  subClientId: string
): Promise<{ liveStatusSettings?: LiveStatusConfig[]; error?: ApiError }> => {
  const response = await getRequest(liveStatusSettingsUrl, { queryParams: { clientId, subClientId } });
  return {
    liveStatusSettings: response?.data,
    error: response?.error,
  };
};

export const updateLiveStatusSettings = async (
  clientId: string,
  subClientId: string,
  liveStatusSettings: LiveStatusConfig[]
): Promise<{ error?: ApiError }> => {
  const response = await postRequest(liveStatusSettingsUrl, {
    body: {
      clientId,
      subClientId,
      liveStatusSettings,
    },
  });

  return {
    error: response?.error,
  };
};
